import { useSearchParams } from 'react-router-dom';
import Teams from '../Teams/Teams';
import Users from '../Users/Users';
import './AuditorRoster.css';

const TABS = [
  { key: 'teams', label: 'Teams' },
  { key: 'users', label: 'Users' },
];

/** Auditor Roster: the audit staff (Users) and how they are grouped (Teams). */
function AuditorRoster() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some((item) => item.key === params.get('tab')) ? params.get('tab') : 'teams';

  return (
    <div className="page roster-page">
      <header className="page__header roster-page__header">
        <div>
          <p className="page__eyebrow">Management</p>
          <h1>Auditor Roster</h1>
          <p className="roster-page__subtitle">
            Your audit staff and the teams they work in.
          </p>
        </div>
      </header>

      <div className="roster-tabs" role="tablist" aria-label="Auditor Roster">
        {TABS.map((item) => (
          <button
            key={item.key}
            type="button"
            role="tab"
            id={`roster-tab-${item.key}`}
            aria-selected={tab === item.key}
            aria-controls={`roster-panel-${item.key}`}
            className={`roster-tabs__tab ${tab === item.key ? 'roster-tabs__tab--active' : ''}`}
            onClick={() => setParams({ tab: item.key }, { replace: true })}
          >
            {item.label}
          </button>
        ))}
      </div>

      <section
        className="roster-panel"
        role="tabpanel"
        id={`roster-panel-${tab}`}
        aria-labelledby={`roster-tab-${tab}`}
      >
        {tab === 'users' ? <Users embedded /> : <Teams embedded />}
      </section>
    </div>
  );
}

export default AuditorRoster;
